import { useEffect, useState } from "react";
import api from "@/lib/api";
import { citiesIn } from "@/lib/carTowns";

/**
 * The towns Toukky's own cars are collected in (lib/carTowns citiesIn):
 * the same list as the cars page's "where to rent". Empty while it loads,
 * when the fleet cannot be read, or when `enabled` is false.
 */
export default function useCarTowns({ enabled = true } = {}) {
  const [towns, setTowns] = useState([]);
  useEffect(() => {
    if (!enabled) return undefined;
    let active = true;
    api.get("/cars")
      .then((r) => { if (active) setTowns(citiesIn(Array.isArray(r?.data) ? r.data : [])); })
      .catch(() => { if (active) setTowns([]); });
    return () => { active = false; };
  }, [enabled]);
  return towns;
}
